import React from "react";
import PropTypes from "prop-types";
import { navigate } from "gatsby";
import { useTheme } from "../theme";
import { HorizontalCard } from "../HorizontalCard";
import { Image } from "../Image";
import { Link } from "../Link";
import { Date } from "../Date";
import { AuthoringInfo } from "./AuthoringInfo";

export function PopularArticle({
    title,
    link,
    heroImage,
    author,
    publishedDate,
}) {
    const {
        altTextColor,
        baseFontSize,
        secondaryTextColor,
        modularScale,
    } = useTheme();

    const goToArticle = async (e) => {
        e.stopPropagation();
        await navigate(link);
    };

    return (
        <HorizontalCard
            image={
                <div className="popular-article__image-container">
                    <Image
                        className="popular-article__image"
                        src={heroImage.src}
                        alt={heroImage.alt}
                    />
                </div>
            }
            onClick={goToArticle}
        >
            <h4 className="popular-article__title">
                <Link className="popular-article__title-link" to={link}>
                    {title}
                </Link>
            </h4>
            <address className="popular-article__author">
                by{" "}
                <span className="popular-article__author-name">
                    {author.name}
                </span>
            </address>
            <time className="popular-article__published-date">
                <Date isoDateString={publishedDate} />
            </time>
            <style jsx>{`
                .popular-article__image-container
                    :global(.popular-article__image) {
                    position: relative;
                    max-width: 200%;
                    left: -50%;
                }
                .popular-article__title {
                    font-size: ${baseFontSize}em;
                    line-height: 1.3;
                    padding-bottom: 0.5em;
                }
                .popular-article__title :global(.popular-article__title-link) {
                    color: ${altTextColor};
                }
                .popular-article__author {
                    font-size: ${modularScale(-1)}em;
                    line-height: 1;
                    font-style: normal;
                }
                .popular-article__published-date {
                    font-size: ${modularScale(-1)}em;
                    line-height: 1;
                    color: ${secondaryTextColor};
                }
            `}</style>
        </HorizontalCard>
    );
}

PopularArticle.propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    heroImage: PropTypes.shape({
        src: Image.propTypes.src,
        alt: Image.propTypes.alt,
    }).isRequired,
    author: PropTypes.shape({
        name: AuthoringInfo.propTypes.authorName,
        avatar: AuthoringInfo.propTypes.authorAvatar,
        link: AuthoringInfo.propTypes.authorLink,
    }).isRequired,
};
